import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=cc13f7c6&"
import script from "./RatingDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc13f7c6')) {
      api.createRecord('cc13f7c6', component.options)
    } else {
      api.reload('cc13f7c6', component.options)
    }
    module.hot.accept("./RatingDisplay.vue?vue&type=template&id=cc13f7c6&", function () {
      api.rerender('cc13f7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yrJT3KKmu2fg/JS/comp/RatingDisplay.vue"
export default component.exports